import { render, staticRenderFns } from "./Joined.vue?vue&type=template&id=23a7a9a4&scoped=true"
import script from "./Joined.vue?vue&type=script&lang=js"
export * from "./Joined.vue?vue&type=script&lang=js"
import style0 from "./Joined.vue?vue&type=style&index=0&id=23a7a9a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a7a9a4",
  null
  
)

export default component.exports